<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-layout">
        <transition-group name="list">
            <div class="form-rows" key="venue-name" v-if="participant && (bookingItem || venue)">
                <div class="fields input readonly half left">
                    <label for="venue_name" v-html="$parent.locale.text_heading_venue"></label>
                    <input class="form-control" name="venue_name" id="venue_name" :value="bookingItem.venue_name + ' (' + bookingItem.venue_town + ')'" readonly>
                    <p v-if="package">{{ $parent.locale.text_change_venue }}, <a @click="changeVenue">click here</a>. {{ $parent.locale.text_change_venue_participant_warning }}</p>
                </div>
                <div class="fields input readonly half right" v-if="participant">
                    <label for="participant_name" v-html="$parent.locale.text_heading_participant"></label>
                    <input name="participant_name" id="participant_name" :value="participant.first_name + ' ' + participant.last_name" readonly>
                    <p v-if="package">{{ $parent.locale.text_change_participant }}, <a @click="changeParticipant">click here</a>. {{ $parent.locale.text_change_venue_participant_warning }}</p>
                </div>
            </div>

            <div class="form-rows form-section" key="quick-weeks" v-if="participant">
                <week-selection :quick="true" :participant="participant" :quickSelection="selection"></week-selection>
            </div>
            <div class="form-rows" v-if="selection.week" key="quick-programme">
                <programme-selection :quick="true" :participant="participant" :quickSelection="selection" :package="package"></programme-selection>
            </div>
            <div class="form-rows form-section" v-if="selection.base instanceof Object  && selection.week != null && participant" key="quick-package">
                <package-selection :quick="true" :edit="true" :toSwap="$parent.booking_item" :participant="participant" :quickSelection="selection"></package-selection>
            </div>
        </transition-group>
    </div>
</template>

<script>
    export default {
        props: ['participant', 'bookingItem', 'package', 'venue'],
        data () {
            return {
                selection: {
                    week: (this.bookingItem ? this.bookingItem.venue_week_id : null),
                    base: (this.package ? this.package.estimated_base_package_template_id : 0),
                },
//                readMore: false
            }
        },
        methods: {
            changeVenue: function () {
                if(this.$route.params.hasOwnProperty('bookingId'))
                    axios.delete('/camp-booking/bookings/'+this.$route.params.bookingId+'/items/'+this.bookingItem.id)
                        .then(response => {
                            if(response.data.data.deleted == true)
                                window.location.href=venues_change_url;
                        })
                else
                    window.location.href=venues_change_url;
            },
            changeParticipant: function () {
                if(this.$route.params.hasOwnProperty('bookingId'))
                    axios.delete('/camp-booking/bookings/'+this.$route.params.bookingId+'/items/'+this.bookingItem.id)
                        .then(response => {
                            if(response.data.data.deleted == true)
                                this.$router.push({ name: 'booking.age', params: { venueId: (this.bookingItem ? this.bookingItem.venue_id : this.$route.params.venueId ) } })
                        })
                else
                    this.$router.push({ name: 'booking.age', params: { venueId: (this.bookingItem ? this.bookingItem.venue_id : this.$route.params.venueId ) } })
            }
        },
        watch: {
            'selection.base': {
                handler: function () {
                    this.readMore = false;
                },
                deep: true
            },
            'selection.week': {
                handler: function () {
                    this.selection.base = null;
                },
                deep: true
            }
        },
        components: {
            'week-selection': require('../../builder/WeeksAvailable.vue'),
            'programme-selection': require('../../builder/BasePackages.vue'),
            'package-selection': require('../../builder/PackageOptions.vue')
        }
    }
</script>



// WEBPACK FOOTER //
// FullWeek.vue?239fc780